import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class FormatoProductosService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetFormatosByCodigo(rutEmpresa, codigoProducto, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $producto_codigo: Decimal) {
            producto_formato {
              obtenerProductosFormatos(filtro: { exacto: { empresa_rut: $empresa_rut, producto_codigo: $producto_codigo, activo: true } }) {
                respuesta {
                  registros {
                    empresa_rut
                    producto_codigo
                    formato_codigo
                    formato_nombre
                    peso_neto
                    volumen
                    fecha_registro
                    cantidad
                    activo
                    formato_codigo_top
                    formato_secundario
                    precio_costo
                  }
                }
              }
            }
          }
        `,
            variables: {
                empresa_rut: rutEmpresa,
                producto_codigo: codigoProducto,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
            //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
            // );
            // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
            // } else {
            //   alert(notificacion.mensajes[0].texto);
            // }
            const { mensajes, respuesta } = response.data.producto_formato.obtenerProductosFormatos;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerDescuentoEspecialProducto(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: productoInputType) {
            producto {
              obtenerProductoDescuentoEspCliente(entidad: $entidad) {
                respuesta {
                  monto_descuento
                  producto_codigo
                  descuento_cliente_codigo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
            //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
            // );
            // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
            // } else {
            //   alert(notificacion.mensajes[0].texto);
            // }
            const { mensajes, respuesta } = response.data.producto.obtenerProductoDescuentoEspCliente;
            callback({ mensajes, respuesta });
        });
    }
    GetFormatosCombinacion1(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: producto_formatoInputType) {
            producto_formato {
              obtenerFormatoCombinacion1(entidad: $entidad) {
                respuesta {
                  empresa_rut
                  producto_codigo
                  formato_codigo
                  formato_nombre
                  cantidad
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto_formato.obtenerFormatoCombinacion1;
            callback({ mensajes, respuesta });
        });
    }
    GetFormatosCombinacion2(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: producto_formatoInputType) {
            producto_formato {
              obtenerFormatoCombinacion2(entidad: $entidad) {
                respuesta {
                  empresa_rut
                  producto_codigo
                  formato_codigo
                  formato_nombre
                  cantidad
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto_formato.obtenerFormatoCombinacion2;
            callback({ mensajes, respuesta });
        });
    }
}
FormatoProductosService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FormatoProductosService_Factory() { return new FormatoProductosService(i0.ɵɵinject(i1.GraphQLClient)); }, token: FormatoProductosService, providedIn: "root" });
